export const experienceStepSX = {
    containerBox: {
        py: 10
    },

    gridContainer: {
        display: "flex",
        justifyContent: "center"
    },

    gridItemBox: {
        p: 3,
        sx: { height: "auto" }
    },

    innerBox: {
        maxWidth: "100%",
        pt: 5
    },

    footerTitleMobile: {
        fontWeight: 600,
        display: { xs: "block", md: "none" },
        textAlign: "center",
        color: "initial",
        mt: 2
    },

    footerTitleDesktop: {
        fontWeight: 600,
        color: "initial",
        textAlign: "center",
        display: { xs: "none", md: "flex" },
        justifyContent: "center",
        alignItems: "center"
    },

    continueButton: {
        display: "flex",
        justifyContent: "flex-end"
    }
};

export const questionOneSX = {
    containerBox: {
        height: "auto"
    },

    questionNameBox: {
        height: { lg: "100px", md: "100px" }
    },

    checkbox: {
        "& .MuiSvgIcon-root": {
            fontSize: "30px !important"
        }
    },

    formControlLabel: {
        border: "1px solid #1c1d1f",
        p: 1,
        m: "3px",
        height: "76px",
        borderRadius: "30px"
    }
};

export const questionTwoSX = {
    containerBox: {
        height: "auto"
    },

    questionNameBox: {
        height: { lg: "100px", md: "100px" }
    },

    formGroup: {
        borderRadius: "30px"
    },

    checkbox: {
        "& .MuiSvgIcon-root": {
            fontSize: "30px !important"
        }
    },

    formControlLabel: {
        border: "1px solid #1c1d1f",
        p: 1,
        m: "3px",
        borderRadius: "30px",
        height: "76px"
    }
};
export const questionThreeSX = {
    containerBox: {
        height: "auto",
    },

    questionNameBox: {
        height: { lg: "100px", md: "100px" },
    },

    radio: {
        "& .MuiSvgIcon-root": {
            fontSize: "30px !important",
        },
    },

    formControlLabel: {
        width: "100%",
        border: "1px solid #1c1d1f",
        p: 1,
        m: "3px",
        height: "76px",
        borderRadius: "30px",
    },
};
